// Varyasyon kombinasyonunun satis fiyati — Listing Builder (tarayici) ve
// Etsy yayini (sunucu) AYNI kurali kullanir.
//
// Kural: seceneklerden birinde (ya da birkacinda) acik satis fiyati
// (sellingPrice) varsa taban o olur (birden fazlaysa en yuksegi); fiyati
// olmayan secenekler priceAdjust'larini ekler. Hicbirinde yoksa: taban fiyat +
// tum priceAdjust'lar.
//
// Takida fiyat 1. eksendedir (kalp sayisi) ve renk ekseninin fiyati yoktur;
// eski kural son eksene baktigi icin tum kombinasyonlar taban fiyatla
// yayinlaniyordu.

export interface PricedOption {
  priceAdjust?: number | null;
  sellingPrice?: number | null;
}

const hasSelling = (o: PricedOption): o is PricedOption & { sellingPrice: number } =>
  typeof o.sellingPrice === "number" && o.sellingPrice > 0;

export function comboPrice(basePrice: number, combo: PricedOption[]): number {
  const explicit = combo.filter(hasSelling).map((o) => o.sellingPrice);
  const base = explicit.length ? Math.max(...explicit) : basePrice;
  const adjust = combo.filter((o) => !hasSelling(o)).reduce((s, o) => s + (Number(o.priceAdjust) || 0), 0);
  return Math.round((base + adjust) * 100) / 100;
}

/**
 * Tum satis fiyatlarina sabit tutar ekler (big print +$5): taban, acik satis
 * fiyatli secenekler ve elle girilmis kombinasyon fiyatlari. priceAdjust'lar
 * fark oldugu icin degismez — comboPrice sonucu her kombinasyonda tam +addon olur.
 */
export function addToAllPrices<T>(
  input: { basePrice: number | null; variations: T; comboPrices?: Array<{ price: number }> | null },
  addon: number,
): { basePrice: number | null; variations: T; comboPrices?: Array<{ price: number }> | null } {
  if (!addon) return input;
  const r2 = (n: number) => Math.round(n * 100) / 100;
  const variations = (Array.isArray(input.variations)
    ? (input.variations as Array<{ options?: PricedOption[] }>).map((v) => ({
        ...v,
        options: (v.options ?? []).map((o) => (hasSelling(o) ? { ...o, sellingPrice: r2(o.sellingPrice + addon) } : o)),
      }))
    : input.variations) as T;
  return {
    basePrice: input.basePrice == null ? null : r2(input.basePrice + addon),
    variations,
    comboPrices: input.comboPrices?.map((c) => ({ ...c, price: r2(c.price + addon) })) ?? input.comboPrices,
  };
}

/** Combo listede bir bedenin Etsy etiketi: elle verilen ad (sizeLabels) yoksa
 *  "prefix + beden". Combo uretimi, sablon senkronu ve siparis eslestirmesi
 *  AYNI etiketi kullanmali, yoksa siparis maliyeti bulunamaz. */
export function comboSizeLabel(
  sc: { sizePrefix?: string; sizeLabels?: Record<string, string> | null },
  size: string,
): string {
  const custom = sc.sizeLabels?.[size]?.trim();
  return custom || `${sc.sizePrefix ?? ""}${size}`;
}
